// extracted by mini-css-extract-plugin
export var path = "CloseButton-module--path--952e7";
export var root = "CloseButton-module--root--3f9db";
export var svg = "CloseButton-module--svg--3b50f";